import { fetch } from '@/utils/http'

export default {
  // 查询个性化配置
  getPersonConfig: params => fetch('get', '/cbaas-service/v1/config/queryPersonConfig', params),
  // 查询链同步时间间隔
  getSyncInterval: params => fetch('get', '/cbaas-service/v1/config/querySyncInterval', params),
  // 修改个性化配置
  setPersonConfig: params => fetch('post', '/cbaas-service/v1/config/modifyPersonConfig', params),
  // 修改链同步时间间隔
  setSyncInterval: params => fetch('post', '/cbaas-service/v1/config/modifySyncInterval', params)
}
